import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { signIn, addAuth, deleteAuth, updateAuth } from '../../api/authApi.js';

export const getAuth = createAsyncThunk('auth/getAuth', async (data) => {
    const response = await signIn(data);
    return response.data;
});

export const createAuth = createAsyncThunk('auth/createAuth', async (newauth) => {
    const response = await addAuth(newauth);
    return response.data;
});

export const removeAuth = createAsyncThunk('auth/removeAuth', async (id) => {
    await deleteAuth(id);
    return id;
});

export const editAuth = createAsyncThunk('auth/editAuth', async ({ id, updatedauth }) => {
    const response = await updateAuth(id, updatedauth);
    return response.data;
});

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
        status: null,
        message: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAuth.fulfilled, (state, action) => {
                state.user = action.payload.data
                state.message = action.payload.msg
                state.status = true
            })
            .addCase(createAuth.fulfilled, (state, action) => {
                state.status = true
                state.message = action.payload.msg
            })
            .addCase(removeAuth.fulfilled, (state, action) => {
                // // console.log({ action });
            })
            .addCase(editAuth.fulfilled, (state, action) => {
                // // console.log({ action });
            });
    },
});

export default authSlice.reducer;
